import { ShippingProviderType } from "@redotech/redo-model/shipment";
import { AddressSchema } from "@redotech/redo-model/team";

import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const RateSchema = z.object({
  id: z.string(),
  shipment_id: z.string(),
  rate: z.string(),
  currency: z.string(),
  carrier: z.string(),
  service: z.string(),
  delivery_date: z.string().nullish(),
  delivery_days: z.number().nullish(),
  delivery_date_guaranteed: z.boolean(),
  upcharge: z.string(),
  is_from_alternative_account: z.boolean(),
  carrier_account_id: z.string(),
  isReturn: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
  shipping_provider_type: createEnum(ShippingProviderType).default(
    ShippingProviderType.EASYPOST,
  ),
  is_merchant_carrier_account: z.boolean().nullish(),
});

export enum PurchaseLabelType {
  Replace = "replace",
  New = "new",
}

export enum PurchaseLabelError {
  CARRIER_ERROR = "carrier_error",
  INTERNAL_ERROR = "internal_error",
  LABEL_PRICE_TOO_HIGH = "label_price_too_high",
}

export const purchaseLabel = {
  name: "purchaseLabel" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    rate: RateSchema,
    shipmentId: z.string().optional(),
    toAddress: AddressSchema,
    fromAddress: AddressSchema,
    labelType: createEnum(PurchaseLabelType),
    originalLabelCost: z.number(),
    isAdditionalShipment: z.boolean().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    shipmentId: z.string().optional(),
    labelUrl: z.string().optional(),
    qrCodeUrl: z.string().optional(),
    trackingNumber: z.string().optional(),
    error: createEnum(PurchaseLabelError).optional(),
    charge: z.number().optional(),
  }),
};
